/* jshint esversion: 6 */


let token;
if (localStorage.__pt) {
	token = localStorage.__pt;
}

const initialState = {

	isGranted: !!(token),
	token_type: '',
	expires_in: null,
	access_token: token,
	errors: {},
	isLoading: false
};

export default (state = initialState, action = {}) => {
	switch (action.type) {
		case 'LOADING_START':
			return Object.assign(
				{
					isLoading: true
				},
				state
			);
		case 'LOADING_FINISH':
			return Object.assign(
				{
					isLoading: false
				},
				state
			);
		case "APP_TOKEN_REQUEST":
			return Object.assign(
				{},
				state
			);

		case "APP_TOKEN_SUCCESS":
			localStorage.setItem('__pt', action.response.access_token);
			return Object.assign(
				{},
				state,
				{
					isGranted: true,
					token_type: action.response.token_type,
					expires_in: action.response.expires_in,
					access_token: action.response.access_token
				}
			);
		case "APP_TOKEN_ERROR":
			return Object.assign(
				{},
				state,
				{ error: action.error }
			);

		default: return state;
	}
};



// WEBPACK FOOTER //
// ./src/app/redux/reducers/misc.js